// src/pages/tournament/FormatSetting.jsx
// Rotating players (the default: partners and opponents change every round), fixed teams (pairs stay the
// same for the whole tournament, see TeamsPanel) or groups and finals (fixed teams in groups, then a knockout). Locked once the tournament has a round or a team, since
// switching under a tournament already under way would leave stale requests, teams or history behind.
import React from 'react';

const FORMATS = [
    ['rotating', 'Rotating players', 'Partners and opponents change every round.'],
    ['fixed-teams', 'Fixed teams', 'Pairs stay the same for the whole tournament, like a doubles league.'],
    ['groups-finals', 'Groups & finals', 'Teams play each other in groups, then the best go through to a knockout.'],
];

function FormatSetting({ format, onSetFormat, locked }) {
    return (
        <section className="card format-card" aria-label="Format">
            <h2 id="format-label">Format</h2>
            <div className="format-kind" role="radiogroup" aria-labelledby="format-label">
                {FORMATS.map(([key, label, hint]) => (
                    <label key={key} className={`format-option${format === key ? ' chosen' : ''}`}>
                        <input
                            type="radio"
                            name="format"
                            checked={format === key}
                            disabled={locked}
                            onChange={() => onSetFormat(key)}
                        />
                        <span>
                            <strong>{label}</strong>
                            <span className="hint">{hint}</span>
                        </span>
                    </label>
                ))}
            </div>
            {locked && (
                <p className="hint">
                    The format is locked once the first round (or, for fixed teams, the first team) is made.
                </p>
            )}
        </section>
    );
}

export default FormatSetting;
